<ion-content [class.ipad-fix]="isIpad" [class.tablet-fix]="isTablet">
  <div *ngIf="!userLoggedIn">
    <video *ngIf="isNative" id="video" preload="auto" autoplay muted loop playsinline class="bg-vid" aria-label="Vídeo de fundo do Flamr">
      <source src="assets/video/veggly.mov" type="video/webm">
      <source src="assets/video/veggly.mov" type="video/mp4">
    </video>
    <img class="logo-veggly" *ngIf="!isNative" src="assets/imgs/logo.svg" alt="Flamr" />
  </div>
  <div class="transparent-box" [class.ipad-transparent-box]="isIpad" [class.tablet-transparent-box]="isTablet">
    <div class="semi-transparent-box" [class.ipad-semi-transparent-box]="isIpad" [class.tablet-semi-transparent-box]="isTablet">
      <div class="white-box" [class.ipad-white-box]="isIpad" [class.tablet-white-box]="isTablet">
        <div class="welcome-text">{{ 'welcomeToVeggly2' | translate }}</div>
        <div class="description">{{ 'findPeople' | translate }}</div>
        <div class="featureButtons">
          <div class="circleButtonWrapper">
            <ion-button (click)="googleSignIn()" [disabled]="processingGoogleSignin" (keydown.enter)="googleSignIn()">
              <div class="featureIcons">
                <img src="assets/imgs/icons/google-icon.svg" alt="Google logo" />
              </div>
            </ion-button>
          </div>
          <div class="circleButtonWrapper">
            <ion-button (click)="loginWithFB()" [disabled]="processingFacebookSignin" (keydown.enter)="loginWithFB()">
              <div class="featureIcons">
                <img src="assets/imgs/icons/facebook-icon.svg" alt="Facebook logo" />
              </div>
            </ion-button>
          </div>
          <div class="circleButtonWrapper" *ngIf="isIos && isNative">
            <ion-button (click)="appleSignin()" [disabled]="processingAppleSignin" (keydown.enter)="appleSignin()">
              <div class="featureIcons">
                <img src="assets/imgs/icons/apple-icon.svg" alt="Apple logo" />
              </div>
            </ion-button>
          </div>
        </div>
        <ion-button (click)="openDefaultLogin()" shape="round" expand="full" class="loginEmail" (keydown.enter)="openDefaultLogin()">
          <div class="featureText">
            {{ 'loginWithEmail' | translate }}
          </div>
        </ion-button>
        <div class="terms-description">
          {{ 'onRegister' | translate }} 
          <a target="_blank" [href]="'https://' + ('termsURL' | translate)" class="highlight-text">{{ 'termsOfUse' | translate }}</a>
          <span>{{ 'and' | translate }}</span>
          <a target="_blank" [href]="'https://' + ('privacyURL' | translate)" class="highlight-text">{{ 'privacyPolicy' | translate }}</a>
          {{ 'vinculate' | translate }} 
        </div>
      </div>
    </div>
  </div>
</ion-content>